export default __webpack_public_path__ + "static/media/DtVhJx26TKEr37c9aBB5knwJxArepzhN.0e89b032.woff2";